import { render } from "./BaseButton.vue?vue&type=template&id=65e04b0b&scoped=true"
import script from "./BaseButton.vue?vue&type=script&lang=js"
export * from "./BaseButton.vue?vue&type=script&lang=js"

import "./BaseButton.vue?vue&type=style&index=0&id=65e04b0b&scoped=true&lang=css"

import exportComponent from "/home/runner/work/accounts.frontend/accounts.frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65e04b0b"]])

export default __exports__